// =========================================================================================
// Contantes globais

export const gConsts = {
    setup : {
        io : {
    //        server : 'https://api.radiomemory.com.br/radiomemory-interno/annotation-service',
    //        server : 'https://pqttag6dpj.execute-api.us-east-1.amazonaws.com/dev/annotation-service-dev',
            server : 'http://35.86.39.228:8646',

    //        server : 'http://54.188.225.134:8530',
    //        server : 'http://54.188.225.134:8532',
            //server : 'https://pqttag6dpj.execute-api.us-east-1.amazonaws.com/dev/annotation-service',
            //server: 'https://3000-indigo-mosquito-4ebs6o7i.ws-us03.gitpod.io',
            reqs : {
                LOAD_PROJ : '/getImgs/',
                LOAD_IMG  : '/img/',
                SAVE_IMG  : '/saveImg/',

                GET_INIT_DATA : '/getInitData/',
                GET_JOB       : '/getJob/',
                SAVE_JOB      : '/saveJob/'
            },


            radiobot: {
                backend: {
                    url: {
                        dev: 'https://api.radiomemory.com.br/sistemasdev/componente/radiobot',
                        prod: 'https://api.radiomemory.com.br/sistemas/componente/radiobot',
                    }
                }
            }
        },
    
        apps : {
            ANNOTS  : 'Annotations',
            RBOT    : 'RadioBot',
            TOMONAV : 'TomoNav'        
        },

        projs : {},

        config : {
            types : {
                APP      : 0,
                INSTANCE : 1
            },
        },
    },

    job : {
        states : {            
            EMPTY     : 0,
            PARTIAL   : 1,
            CONFIRMED : 2,
            DOUBT     : 3, 
            DIVERGENT : 4,
            DISCARDED : 5,            
        },

        stateUpdates : {
            TOOL_ADD            : 0, 
            TOOL_DELETE         : 1,
            TOOL_UPDATE_OTHER   : 2,
            TOOL_UPDATE_STATE   : 3,
            TOOL_ADD_PTS        : 4,
            TOOL_DEL_PTS        : 5,
            JOB_RESET_DOUBT     : 6,
            JOB_RESET_DISCARDED : 7
        },

        colors : {
            EMPTY     : '#eeeeee',
            PARTIAL   : '#ffdf8f',
            DOUBT     : '#da8fff',
            DIVERGENT : '#ff8f8f',
            DISCARDED : '#178ecf',
            CONFIRMED : '#c5ecc7'
        },

        controls : {
            DOUBT   : 0,
            DISCARD : 1,
            BACK    : 2,
            SKIP    : 3,            
            CONFIRM : 4
        },
        
        info : {
            type : {
                NEW : 'new',
                EDIT : 'edit'
            }
        }
    },

    rt : {
        execModes : {
            WORK : 'work',
            VIEW : 'view',
            EXPORT : 'export'
        },
    },

    node : {
        layout : {
            parents : {
                ROOT : 'root',
            },

            types : {
                LABEL     : 'lb'       ,
                NEW_LABEL : 'new_lb'   ,
                LAYER     : 'layer'    ,
                STEP      : 'step'     ,
                QUALIFIER : 'qualifier',
                CUSTOM_LINE : 'customLine',
            },

            groups : {
                FOLDER         : 'folder',         // group child nodes under a folder named with the node caption
                SET            : 'set'   ,         // logical node, not visible (items are listed under node's parent)
                HIDDEN         : 'hidden',         // node (and child nodes) not visible (they are only used internally)
                SELECT         : 'select',         // dropdown select of child nodes after [node.layout.caption]
                RADIO_GROUP    : 'radioGroup',     // radio group with the child nodes under [node.layout.caption]
                CHECKBOX_GROUP : 'checkboxGroup',  // checkbox group with the child nodes under [node.layout.caption]
                ODONTG         : 'odontG'          // odontogram with layers labels (used for teeth labels)'
            }
        }, 

        report : {
            types : {
                SECTION          : 'section'      ,  // report section/subsection
                LOCATION_LIST    : 'locationList' ,  // report line is formed by text + related tooth/toothRegion/anatRegion list
                NODE_LIST        : 'nodeList'     ,  // report line is formed by text + child node list
                NODE_LIST_ITEM   : 'nodeListItem' ,  // node doesn't have a report line (it's one of the list items of it's parent node)
                SELECTED_NODE    : 'selectedNode' ,  // report line is formed by text + selected child node text (used for [folder : SELECT / RADIO_GROUP] layers)
                SELECTED_NODES   : 'selectedNodes',  // report line is formed by text + selected child node text (used for [folder : CHECKBOX_GROUP ] layers)
                SELECT_ITEM      : 'selItem'      ,  // node doesn't have a report line (it's a selectable item of it's parent node)
                TEXT             : 'text'         ,  // report line is formed by caption text
                NONE             : 'none'         ,  // layer is not part of the report
            },
            annotation: {
                types: { // Usado para especificar o tipo de anotação de um label
                    LOCATION : 'location',
                    TOOTH : 'tooth',
                    RTOOTH : 'r_tooth',
                    FIXED : 'fixed',
                    ANAT_ONLY : 'anat_only',
                    ANAT_RTOOTH : 'anat_rtooth',
                    PROX_ANAT_RTOOTH : 'prox_anat_rtooth',
                    RX_SIDE : 'rx_side',
                },
                /**
                 * Tipos de associacoes de anotacoes. Serve para especificar como as anotacoes devem ser agrupadas no relatório.
                 */
                association: {
                    /**
                     * Anotacao individual. Cada anotacao é um item separado.
                     */
                    INDIVIDUAL: 'individual',
                    /**
                     * Anotacao em grupo. Todas as anotacoes monta apenas um item.
                     */
                    GROUP: 'group',
                },
                colors: {
                    DEFAULT: '#0F4C64',
                }
            }
        },

        location : {
            internal: { // Localizacoes internas relacionado aos dentes.
                faces: {
                    types: {
                        MESIAL: 'mesial',
                        DISTAL: 'distal',
                        CERVICAL: 'cervical',
                        OCLUSAL: 'oclusal',
                        INCISAL: 'incisal',
                    }
                },
                regions: {
                    types: {
                        CORONARIO: 'coronario',
                        RADICULAR: 'radicular',
                        CERVICAL: 'cervical',
                        MEDIA: 'media',
                        APICAL: 'apical',
                        APICAL_EXTENSAO: 'apicalExtensao',
                    }
                }
            }
        },
        qualifier: {
            types: {
                MESIODENTE: 'mesiodente',
                DISTOMOLAR: 'distomolar',
                ADAPTACAO_RESTAURACAO: 'adaptacaoRestauracao',
                MATERIAL_AQUEM: 'materialAquem',
                MATERIAL_ALEM: 'materialAlem',
                FRATURA: 'fratura',
                PERFURACAO: 'perfuracao',
                TREPANACAO: 'trepanacao',
                PERDA_OSSEA: 'perdaOssea',
                PERI_IMPLANTITE: 'periImplantite',
                TOTAL: 'total',
                PARCIAL: 'parcial',
                DISCRETA: 'discreta',
                MODERADA: 'moderada',
                SEVERA: 'severa',
            },
            line: {
                types: {
                    SAME_LINE: 'sameLine',
                    NEW_LINE: 'newLine',
                }
            }
        },

        layerTools : {            
            pFunctions : {  // Primary function of tools from the layer
                SELECT     : 'select',   // select option nodes
                ANNOTATION : 'annot',    // annotation/input tools
                LOCATION   : 'location'  // location tools
            },
    
            visibility : {
                LAYER       : 'layer'     ,  // layer tools visible when layer active
                LABEL       : 'label'     ,  // only tools of current active label (of the active layer) are visible
                GLOBAL      : 'global'    ,  // layer tools allways visible
                NONE        : 'none'         // layer tools never visible
            },

            actions : {
                INPUT  : 'input' ,   
                MOVE   : 'move'  ,     
                EDIT   : 'edit'  ,   
                DELETE : 'delete',  
            },    
        },

        search : {
            actions : {
                NAV_NEXT : 'navNext' ,
                NAV_PREV : 'navPrev' ,
                DISABLE  : 'disable' ,
                INPUT    : 'input',
                LOCATION_FILTER : 'locationFilter'
            }
        }
    },

    step : {
        ids : {
            DENTICAO : 0,
            PROCS    : 1,
            ACHADOS  : 2,
            LIVRE    : 3,

            METAIS   : 4,  // DEPRECATED? - usava antes ... não vou usar mais ... tem que tirar
        },

        folderTypes : {
            ROOT        : 0,
            LAYER_NAME  : 1,
            NOT_VISIBLE : 2
        },

        // legado ... ver como estah sendo usado e resolver se vai manter -------------------        
        layers : {},
        descs  : {},
        texts  : {}
        // ----------------------------------------------------------------------------------
    },

    layer : {
        locations : {
            TEETH_LE      : 'layer_dentesLE',
            TEETH_INTERNAL: 'layer_dentesInternal',
            TEETH_PROVAVEL: 'layer_dentesProvavel',
            TEETH_SEG     : 'layer_dentesSeg',
            ANAT_CONTOURS : 'layer_contornosAnat',
            ANAT_REGIONS  : 'layer_regioesAnat',
            ANAT_PTS      : 'layer_ptosAnat'
        },

        ids : {
            DENTES_LE       : 'DENTES_LE',
            DENTES_SEG      : 'DENTES_SEG',
            PROCS           : 'PROCS',
            METAIS          : 'METAIS',
            ORTO            : 'ORTO',
            ACHADOS         : 'ACHADOS',
            PANORAMOGRAMA   : 'PANORAMOGRAMA',
            LIVRE           : 'LIVRE'
        },

        // Define se pulamos para o proximo label da layer depois de uma insercao ou nao
        jumpTypes : {
            AUTOMATIC : 0, 
            MANUAL    : 1   // default
        },        

        // Define se a layer é de navegação, ou somente inserção
        types : {
            ANNOTATION : 'annot'   ,
            LOCATION   : 'location',
            
            NAVEGATION : 0,  // deprecated
            INPUT      : 1   // deprecated
        },

        navTypes : {
            NONE   : 0,
            HOVER  : 1, 
            ANCHOR : 2, 
        },

        // Tipos de manipulações possíveis para as tools da layer
        manipulationTypes : {
            MOVE   : 0, 
            EDIT   : 1, 
            INPUT  : 2, 
            DELETE : 3,
            ALL    : 4
        },
        
        allLayers : {
            DENTE : 'Segmentacao',
            SEG   : 'Segmentacao',
            PROC  : 'Procedimentos',
            METAL : 'Metais',
            ANOM  : 'Anomalias',
            LIVRE : 'Panorograma',
            PANORAMOGRAMA : 'Panorograma',
        },

    },

    elem : {
        ids : {
            PAN        : 'pan'      , 
            PERI       : 'peri'     , // tvz tenha que ter um id pra cada periapical
            INTER_PROX : 'interProx',
            TELE       : 'tele'     ,
            FRONTOL    : 'frontal'  ,
            CARPAL     : 'carpal'   ,
            IO_ESQ     : 'ioEsq'    ,
            IO_DIR     : 'ioDir'    ,
            EO_SORRISO : 'eoSorriso',
            EO_PERFIL  : 'eoPerfil' ,
            EO_FRENTE  : 'eoFrente' 
        },

        subIds : {  // ids para cada periapical
            PERI_1 : 'peri_1'
        },

        attrib: {
            types: {  
                SINGLE_IMG  : 'singleImg' ,  // 0,
                MULTI_SLICE : 'multiSlice',  // 1,
                VOL3D       : 'vol3D'        // 2
            },

            modes : {  
                SLICE : 'slice',
                MIP   : 'mip',
                DRR   : 'drr',
                RX    : 'rx',
                COLOR : 'color',
                VOL3D : 'vol3D',
            }
        },

        location: {
            types: {
                LEFT: 'lado_esquerdo',
                RIGHT: 'lado_direito',
                BOTH: 'ambos_lados',
            },
            report: {
                'lado_esquerdo': "lado esquerdo",
                'lado_direito': "lado direito",
                'ambos_lados': "ambos os lados",
            },
            especificacao: {
                group: {
                    types: {
                        SITUACAO: 'situacao',
                        DESVIO: 'desvio',
                        LADO: 'lado',
                    },
                },
                lado: {
                    ESQUERDO: "lado__esquerdo",
                    DIREITO: "lado__direito",
                    AMBOS: "lado__ambos",
                },
                desvio: {
                    PARA_DIREITA: "desvio__para_direita",
                    PARA_ESQUERDA: "desvio__para_esquerda",
                },
            }
        }
    },

    tool : {
        attrib : {
            types : {                 
                NO_TOOL       : '',
                PONTO         : 'pto'      ,  // 7
                RETA          : 'reta'     ,  // 0
                RETANGULO     : 'retang'   ,  // 1
                CIRCULO       : 'circ'  ,     // 2
                IMG_LABEL     : 'imgLb'    ,  // 3
                RETANGULO_INC : 'retangInc',  // 4
                PATH          : 'path'     ,  // 5
                CURVA         : 'curv'        // 6
            },

            iaMethods : {
                NONE           : 'none'     ,  // manual creation 
                CLASSIFICATION : 'class'    , 
                UNET_SEG       : 'unetSeg'  ,  // segmentacao
                UNET_PT        : 'unetPt'   ,  // segmentacao
                UNET_CURV      : 'unetCurv' ,  // segmentacao    
                OBJ_DETECT     : 'objDetect',
                MULTIPLE       : 'multiple'
            },
        },

        state : {
            confidence : {
                OK        : 'ok',     // 0
                DOUBT     : 'doubt',  // 1
                DIVERGENT : 'div'     // 2
            },

            inputs : {
                MANUAL    : 'manual',    // 0,
                BOT       : 'bot'   ,    // 1, não necessariamente por IA, mas todas as geradas automaticamente.
                MIXED     : 'mixed' ,    // 2, ... started as a BOT, but was modified by a human
                DISCARDED : 'discarded'  // 3  ... started as a BOT, but was deleted by a human
            },

            visual : {
                ANNOT_HIDDEN               : 'annotHidden'              ,  // annotation tool is not visible on the image
                ANNOT_INACTIVE             : 'annotInactive'            ,  // annotation tool is visible (discreetly)
                ANNOT_INACTIVE_ACTIVELABEL : 'annotInactive_activeLabel',  // annotation tool is visible (a with a little more presence because it belongs to the activeLabel)
                ANNOT_ACTIVE               : 'annotActive'              ,  // annotation tool is visible and active (highlighted)
                ANNOT_EDIT                 : 'annotEdit'                ,  // annotation tool is visible, active and shows the current rt.mov.type 
                LOCATION_HIDDEN            : 'locationHidden'           ,  // location tool is not visible on the image
                LOCATION_INACTIVE          : 'locationInactive'         ,  // location tool is visible (discreetly) 
                LOCATION_ACTIVE_TOOTH      : 'locationActiveTooth'      ,  // location tool is visible and active (but still discreet since it's only a location aid for the annotations) - toothSeg
                LOCATION_ACTIVE_OTHER      : 'locationActiveOther'      ,  // location tool is visible and active (but still discreet since it's only a location aid for the annotations) - otherLocations

                NONE      : 'none'     ,
                INACTIVE  : 'inactive' ,
                CITED     : 'cited'    , 
                ACTIVE    : 'active'   ,
                HOVER     : 'hover'    ,
                MOVING    : 'moving'   ,
                LOCATIONS : 'locations',
                LOCATION  : 'location' ,
                VIEW_LABEL_LOCATIONS : 'viewLabelLocations',
                VIEW_LOCATION        : 'viewLocation' ,
            },
        },  
        
        labelPos : {
            ORIGIN : 0,
            END    : 1
        },

        colors : {
            normal : '#19ff19',
            active : 'red'
        },        
        
        handle : {
            HOVER_INDEX : 1,
            opacity : {
                NORMAL : 0.3,
                MOVING : 0.05
            }       
        },

        metrics : {
            HANDLES_PUSH_DIST : 25,
            CURVE_CREATION_MIN_DIST  : 15,
            CURVE_CREATION_MAX_DIST  : 60,
            CURVE_CREATION_MIN_ANGLE : 3,
            ISIN_MAX_DIST : 5,
        },
    },

    label : {
        states : {
            UNUSED : 0,
            USED   : 1
        },

        colors : {
            DEFAULT : '#00FF00',
            toothInternal : {
                DEFAULT  : '#80FF00', // yellow-green
                LONGAXIS: '#80FF00', // yellow-green
                LONGAXISBASEMANDIBULA: '#FF0000', // red
                CONTOUR: '#000000', // black
                COROA__INCISAL  : '#00B8D9', // teal blue
                COROA__OCLUSAL  : '#1976D2', // rich blue
                COROA__CERVICAL : '#FFB300', // deep orange
                COROA__MESIAL   : '#D32F2F', // red
                COROA__DISTAL   : '#8E24AA', // purple
                RAIZ__DISTAL    : '#8E24AA', // purple
                RAIZ__MESIAL    : '#D32F2F', // red
                DENTE_COMPLETO__COROA : '#96bc19', // light black
                DENTE_COMPLETO__RAIZ : '#CCCCCC', // light gray
                RAIZ__CERVICAL : '#FFB300', // deep orange
                RAIZ__MEDIA : '#8E24AA', // purple
                RAIZ__APICAL : '#D32F2F', // red
            },
            UNUSED  : '#292eb2',
            USED    : '#afdbb2'
        },

        jumps : {
            AUTOMATIC : 0, 
            MANUAL    : 1
        },

        texts: {},

        types : {
            DENTES        : 'DENTES',
            PROCS         : 'PROCS',
            METAIS        : 'METAIS',
            ORTO          : 'ORTO',
            ACHADOS       : 'ACHADOS',
            PANORAMOGRAMA : 'PANORAMOGRAMA',
            LIVRE         : 'LIVRE'
        }
    },

    dente : {
        ROI : {
            margins : {
                vert  : 0.3,
                horiz : 0.5
            }
        },

        navTypes : {
            DYNAMIC : 0,
            FIXED   : 1
        },

        navIncs : {
            PREVIOUS : -1,
            NEXT     :  1
        },

        scanOrder : ['18', '17', '16', '15', '14', '13', '12', '11', 
                     '21', '22', '23', '24', '25', '26', '27', '28', 
                     '38', '37', '36', '35', '34', '33', '32', '31', 
                     '41', '42', '43', '44', '45', '46', '47', '48'],

        regions : {
            MAX_DISTANCE: 30,
        }
    },

    denticao : {
        LAYER : 'layer_tipoDenticao',

        types : {
            DECIDUA    : 'lb_denticaoDecidua',
            MISTA      : 'lb_denticaoMista',
            PERMANENTE : 'lb_denticaoPermanente'
        },

        dentes : {
            DECIDUA : ['51', '52', '53', '54', '55',
                       '61', '62', '63', '64', '65',
                       '71', '72', '73', '74', '75',
                       '81', '82', '83', '84', '85'], 

            MISTA : ['11', '12', '13', '14', '15', '16', '17', '18',
                     '21', '22', '23', '24', '25', '26', '27', '28', 
                     '31', '32', '33', '34', '35', '36', '37', '38',
                     '41', '42', '43', '44', '45', '46', '47', '48',
                     '51', '52', '53', '54', '55',
                     '61', '62', '63', '64', '65',
                     '71', '72', '73', '74', '75',
                     '81', '82', '83', '84', '85'],

            PERMANENTE : ['11', '12', '13', '14', '15', '16', '17', '18',
                          '21', '22', '23', '24', '25', '26', '27', '28', 
                          '31', '32', '33', '34', '35', '36', '37', '38',
                          '41', '42', '43', '44', '45', '46', '47', '48'],
        } 
    },

    mov : {
        types : {
            WA_PAN        : 0,
            IMG_BC        : 1,
            TOOL_CREATION : 2,            
            TOOL_DRAG     : 3,
            TOOL_HOVER    : 4,
            HANDLE_DRAG   : 5,
            HANDLES_PUSH  : 6,
            HANDLES_DEL   : 7,
            LABEL_DRAG    : 8 ,
            SEGMENTATION_FIX_CREATION : 9
        },

        mouseLocations : {
            WORK_AREA   : 'wa',
            SIDE_PANELS : 'sps',
            OTHER       : 'other'
        },

        focusLocations : {
            SIDE_PANEL_JOBS : 'spJobs',
            SIDE_PANEL_ANNOTATIONS : 'spAnnots',
            SIDE_PANEL_RELATORIO_DINAMICO : 'spRelatorioDinamico',
            SIDE_PANEL_REPORT : 'spReport',
            SIDE_PANEL_CONFIG : 'spConfig',
            SIDEBAR_PANELS_RELATORIO : 'sidebarPanelsRelatorio',
            SIDEBAR_PANELS_PESQUISA : 'sidebarPanelsPesquisa',
            SIDEBAR_PANELS_ANATOMIA : 'sidebarPanelsAnatomia',
            LABEL_SEARCH_POPUP : 'labelSearchPopup',
            POPUP_ANOTACAO : 'popupAnotacao',
            POPUP_CONFIRM_SEGMENTATION_FIX : 'popupConfirmSegmentationFix',
            WORK_AREA : 'wa',
            OTHER : 'other'
        },
    },

    ui : {
        toolbar : {
            ids : {
                IMG_TOOLS   : 'imgTools',
                UNDO_REDO   : 'undoRedo',
                ANNOT_TOOLS : 'annotTools',
                OTHER       : 'other'
            },

            buttons : {
                WA_PAN        : 'waPan',
                IMG_BC        : 'imgBC',
                IMG_ORIGIN    : 'imgOrigin',                
                FIT_TO_WA     : 'fitToWa',
                SAVE_IMG      : 'saveImg', 
                CROSS_HAIR    : 'crossHair',
                FIX_SEGMENTACAO_DENTE : 'fixSegmentacaoDente',
                UNDO          : 'undo',
                REDO          : 'redo',
                PONTO         : 'pto',
                RETA          : 'reta',
                RETANGULO     : 'retang',
                CIRCULO       : 'circ',
                RETANGULO_INC : 'retangInc',
                PATH          : 'path',
                CURVA         : 'curv',
                DEL_TOOL      : 'delTool',
                IMG_LABEL     : 'imgLb',
                EXEC_MODE     : 'execMode',
                FULL_SCREEN   : 'fullScreen',
                RESET_JOB     : 'resetJob',
            },

        },
            
        sidePanel : {
            ids : {
                JOBS    : 'spJobs'    ,
                ANNOTS  : 'spAnnots'  ,
                RELATORIO_DINAMICO : 'spRelatorioDinamico',
                REPORT  : 'spReport'  ,
                CONFIG  : 'spConfig'  ,
                AJUST3D : 'spAjuste3D',
            },

            sides : {
                RIGHT : 'right',
                LEFT  : 'left'
            },

            timeouts : {
                SEARCH_COLLAPSE : 2000,
                COLLAPSE        : 1000,
                ACTIVATE        : 300
            }
        },

        shortcuts : {
            NEXT :  1,
            PREV : -1
        },

        workArea : {
            zoom : {
                MIN : 0.05,
                MAX : 10                
            },
            cssVars : {
                zoom : '--wa-zoom-scale',
            },
        },

        colorTheme: {
            types : {
                DARK  : 0,
                LIGHT : 1
            },

            themes : {
                DARK  : 0,
                LIGHT : 1,
            },

            data : [
                { 
                    name         : 'dark',
                    type         :  0,
                    header       : '#2B536A',
                    footer       : '#333333',
                    panels       : '#888888',
                    workArea     : '#1E1E1E',  
                    toolbar      : '#252526',
                    buttons      : '#e9e9e9',
                    titles       : 'white',
                    sidePanels   : '#888888',
                    spHandle     : '#252526',
                    sel_spHandle : '#d3d353'
                },

                {
                    name         : 'light',
                    type         : 1,
                    header       : '#2B536A',
                    footer       : '#dddddd',
                    panels       : '#d5d5d5', 
                    toolbar      : '#efefef', 
                    workArea     : '#f5f5f5', 
                    buttons      : '#e9e9e9',
                    titles       : 'black',
                    sidePanels   : '#FFFFFF',
                    spHandle     : '#d3d3d3',
                    sel_spHandle : '#9fa9c2'
                }
            ]
        },

        prettyColors : {
            // Mapeamento de cores genericas para cores mais bonitas
            'red': '#EF4444',
            'yellow': '#EAB308',
            'green': '#008000',
            'blue': '#3B82F6',
        }
    },
};

gConsts.setup.projs[gConsts.setup.apps.RBOT] = { 
    LAUDO_PADRAO : 'laudoPadrao' 
};

gConsts.step.layers[gConsts.step.ids.DENTICAO] = gConsts.layer.allLayers.SEG; 
gConsts.step.layers[gConsts.step.ids.PROCS   ] = gConsts.layer.allLayers.PROC; 
gConsts.step.layers[gConsts.step.ids.METAIS  ] = gConsts.layer.allLayers.METAL; 
gConsts.step.layers[gConsts.step.ids.ACHADOS ] = gConsts.layer.allLayers.ANOM; 
gConsts.step.layers[gConsts.step.ids.LIVRE   ] = gConsts.layer.allLayers.LIVRE;

gConsts.step.descs[gConsts.step.ids.DENTICAO] = 'Dentição';
gConsts.step.descs[gConsts.step.ids.PROCS   ] = 'Procedimentos';
gConsts.step.descs[gConsts.step.ids.METAIS  ] = 'Metais';
gConsts.step.descs[gConsts.step.ids.ACHADOS ] = 'Achados';
gConsts.step.descs[gConsts.step.ids.LIVRE   ] = 'Livre';

gConsts.step.texts[gConsts.step.ids.DENTICAO] = 'Tipo de dentição (c/ ausent. e extranum.)';
gConsts.step.texts[gConsts.step.ids.PROCS   ] = 'Procedimentos presentes';
gConsts.step.texts[gConsts.step.ids.METAIS  ] = 'Metais presentes';
gConsts.step.texts[gConsts.step.ids.ACHADOS ] = 'Descrição dos achados (anomalias e outras alterações)';
gConsts.step.texts[gConsts.step.ids.LIVRE   ] = 'Outros achados importantes';



